import React, { useMemo } from 'react';
import { IFieldParameters } from '../../../Map/slice/types';
import { useDispatch } from 'react-redux';
import { Card, Collapse, List } from 'antd';
import { useMapSlice } from 'app/containers/Map/slice';
import { useTranslation } from 'react-i18next';
import { getAreaWithUnits } from 'utils/helpers';

interface IProps {
  mappedFieldParams: IFieldParameters[];
}

const CompanyCultureFieldsList = ({ mappedFieldParams }: IProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { actions: mapActions } = useMapSlice();

  const totalArea = useMemo(() => {
    return mappedFieldParams.reduce((total, field) => total + field.areaNum, 0);
  }, [mappedFieldParams]);

  return (
    <Card>
      <Collapse>
        <Collapse.Panel
          header={t('Field.SelectedFieldsSummary.Header', {
            defaultValue: '{{count}} field / {{area}}',
            count: mappedFieldParams.length,
            area: getAreaWithUnits(totalArea),
          })}
          key="1"
        >
          <List
            dataSource={mappedFieldParams}
            renderItem={(item: IFieldParameters) => (
              <List.Item
                onClick={() => dispatch(mapActions.zoomOnPolygon(item.fieldId))}
              >
                <List.Item.Meta
                  title={item.name}
                  description={`${
                    item.cultureName ||
                    t('Common.WithoutCulture', 'Without culture')
                  } | ${item.area}`}
                />
              </List.Item>
            )}
          ></List>
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};

export default CompanyCultureFieldsList;
